const modalIds = ['listarContasModal', 'exampleModalToggle2', 'ModalToggleRecibo']
const states = new WeakMap()
const storageKey = 'modalHref'

function initialize(root, Modal) {
  const details = root.getElementById(modalIds[0])
  if (!details || states.has(details)) return

  const modals = modalIds.map(id => root.getElementById(id))
  const payment = modals[1]
  const receipt = modals[2]
  const date = root.getElementById('input-data')
  const form = root.getElementById('pagarContaForm')
  const confirm = root.getElementById('confirmarPagamentoLink')
  const state = { caching: false, switching: false, receiptRequest: null, submitting: false }
  states.set(details, state)

  const detailsLinks = root.querySelectorAll('a[data-bs-target="#listarContasModal"][href]')
  detailsLinks.forEach(link => link.addEventListener('click', () => {
    state.detailsLink = link
    sessionStorage.setItem(storageKey, link.getAttribute('href'))
  }))

  modals.forEach(modal => {
    modal.addEventListener('hidden.bs.modal', () => {
      if (modal === receipt && state.receiptRequest) state.receiptRequest.abort()
      if (!state.switching && !state.caching) {
        sessionStorage.removeItem(storageKey)
        if (state.detailsLink) state.detailsLink.focus()
      }
    })

  })

  // Bootstrap delegates clicks on document in capture; handle transfers first.
  const switchModal = event => {
    const button = event.target.closest('[data-bs-toggle="modal"]')
    if (!button) return
    const modal = button.closest('.modal')
    const target = modals.find(item => `#${item.id}` === button.getAttribute('data-bs-target'))
    if (!modals.includes(modal) || !target || target === modal) return

    event.preventDefault()
    event.stopPropagation()
    if (state.switching) return

    state.switching = true
    if (modal === details) state.returnFocus = button
    modal.addEventListener('hidden.bs.modal', () => {
      Modal.getOrCreateInstance(target).show(button)
      state.switching = false
      if (target === details && state.returnFocus) state.returnFocus.focus()
    }, { once: true })
    Modal.getOrCreateInstance(modal).hide()
  }
  window.addEventListener('click', switchModal, true)
  state.removeClickHandler = () => window.removeEventListener('click', switchModal, true)

  payment.addEventListener('show.bs.modal', event => {
    const button = event.relatedTarget
    form.reset()
    state.submitting = false
    confirm.disabled = true
    root.getElementById('form-item-id').value = button.getAttribute('data-item-id') || ''
    root.getElementById('form-item-acao').value = button.getAttribute('data-item-acao') || ''
    root.getElementById('form-valor-final').value = button.getAttribute('data-valor-final') || ''
    root.getElementById('form-data-escolhida').value = ''
  })

  date.addEventListener('input', () => {
    root.getElementById('form-data-escolhida').value = date.value
    confirm.disabled = state.submitting || !date.value || !date.validity.valid
  })

  form.addEventListener('submit', event => {
    if (state.submitting || !date.value || !date.validity.valid || !root.getElementById('form-item-id').value) {
      event.preventDefault()
      return
    }
    root.getElementById('form-data-escolhida').value = date.value
    state.submitting = true
    confirm.disabled = true
  })

  receipt.addEventListener('show.bs.modal', event => {
    if (state.receiptRequest) state.receiptRequest.abort()
    const request = new AbortController()
    state.receiptRequest = request
    const loading = receipt.querySelector('.carregando-recibo')
    const content = receipt.querySelector('.background-imprimir')
    const error = receipt.querySelector('.recibo-erro')
    const print = root.getElementById('imprimirRecibo')
    loading.hidden = false
    content.hidden = true
    error.hidden = true
    print.disabled = true

    const itemId = event.relatedTarget.getAttribute('data-item-id')
    fetch(`/contas/${encodeURIComponent(itemId)}.json`, { signal: request.signal })
      .then(response => {
        if (!response.ok) throw new Error('Falha ao carregar recibo')
        return response.json()
      })
      .then(data => {
        if (request.signal.aborted) return
        const fields = {
          'recibo-nome': data.cliente_nome,
          'recibo-valor': data.valor_pago_parcela,
          'recibo-valor-extenso': data.valor_pago_parcela_extenso,
          'recibo-numero-parcela': `Parcela ${data.numero_parcela} de ${data.quantidade_parcela}`,
          'recibo-data': data.data_pg,
          'recibo-nome-footer': data.cliente_nome,
          'recibo-venda-veiculo-dados': data.venda_veiculo_dados
        }
        Object.keys(fields).forEach(id => { root.getElementById(id).textContent = fields[id] || '' })
        loading.hidden = true
        content.hidden = false
        print.disabled = false
      })
      .catch(() => {
        if (request.signal.aborted) return
        loading.hidden = true
        error.hidden = false
      })
  })

  const url = new URL(window.location.href)
  if (url.searchParams.get('limpar') === 'yes') {
    sessionStorage.removeItem(storageKey)
    url.searchParams.delete('limpar')
    window.history.replaceState({}, '', url.pathname + url.search + url.hash)
  }

  const savedHref = sessionStorage.getItem(storageKey)
  const savedLink = Array.from(detailsLinks).find(link => link.getAttribute('href') === savedHref)
  if (savedLink) savedLink.click()
  else sessionStorage.removeItem(storageKey)
}

function beforeCache(root, Modal) {
  const details = root.getElementById(modalIds[0])
  const state = states.get(details)
  if (!state) return

  state.caching = true
  state.removeClickHandler()
  if (state.receiptRequest) state.receiptRequest.abort()

  // These modals have no fade, so hide finishes before Turbolinks clones the DOM.
  modalIds.forEach(id => {
    const modal = root.getElementById(id)
    const instance = Modal.getInstance(modal)
    if (instance) {
      instance.hide()
      instance.dispose()
    }
  })
}

module.exports = { initialize, beforeCache }
